import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';

export default {
  name: 'Confirm',

  components: {
    SharedHeader,
    SharedFooter,
  },

  data: () => {
    return {};
  },
};
